<template>
  <div id="public_loading" class="tal_c">
    <p>
      {{ $t(`msg.loading`) }} 
      <span class="public_loading_1">.</span>
      <span class="public_loading_2">.</span>
      <span class="public_loading_3">.</span>
    </p>
  </div>
</template>
<script>
export default {
  props: ["text"],
  created() {},
  mounted() {
      if(!this.text){
          this.text = "loading"
      }
  },
  data: () => ({}),
  components: {},
  methods: {},
  computed: {},
  watch: {}
};
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/public/BaseLoading.vue